import { ArrowLeft, Mail, ShieldCheck } from "lucide-react";
import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { apiRequest, ApiError } from "../lib/api";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await apiRequest("/auth/forgot-password", { method: "POST", body: JSON.stringify({ email }) });
      setSent(true);
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : "No pudimos procesar la solicitud");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="auth-top"><Link to="/login" className="icon-link"><ArrowLeft size={20} /></Link><Logo compact /></div>
      <div className="auth-card">
        {sent ? (
          <div className="recovery-result"><span><Mail size={28} /></span><h1>Revisá tu correo</h1><p>Si existe una cuenta con ese email, vas a recibir un enlace válido durante 30 minutos.</p><Link className="button primary large" to="/login">Volver a ingresar</Link></div>
        ) : (
          <>
            <div className="auth-heading"><span className="step-label">Recuperación segura</span><h1>Restablecé tu contraseña</h1><p>Ingresá el email de tu cuenta LingoSound y te enviaremos un enlace de recuperación.</p></div>
            <form onSubmit={submit} className="form-stack">
              <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" placeholder="tu@email.com" required /></label>
              {error && <div className="form-error" role="alert">{error}</div>}
              <button className="button primary large" disabled={busy}>{busy ? "Enviando…" : "Enviar enlace"}</button>
            </form>
            <p className="security-note"><ShieldCheck size={17} /> Nunca te pediremos tu contraseña por email.</p>
          </>
        )}
      </div>
    </div>
  );
}
